import React from 'react';

const statusColors = {
  completed: 'bg-emerald-500',
  in_progress: 'bg-amber-500',
  requested: 'bg-amber-500',
  pending: 'bg-amber-500',
  cancelled: 'bg-red-500',
  canceled: 'bg-red-500',
  default: 'bg-slate-400',
};

export const AdminBadge = ({ children, count }) => (
  <span className="admin-badge">
    {children}
    {count != null && <span className="opacity-70">{count}</span>}
  </span>
);

export const AdminStatus = ({ status, label }) => {
  const dotClass = statusColors[status] || statusColors.default;
  return (
    <span className="inline-flex items-center gap-2 text-sm font-medium text-[#0c0f14]">
      <span className={`admin-status-dot ${dotClass}`} />
      {label || status?.replace(/_/g, ' ')}
    </span>
  );
};

export default AdminBadge;
